/**
 * EncodingTypes for values
 */
export enum EncodingTypes {
    Url = 0,
    Html = 1,
    HtmlAttribute = 2,
    Javascript = 3,
    Base64 = 4
}